import styled from "styled-components"
import testimonialsImage from '../../../assets/images/home/testimonials.svg'

export const TestimonialsImage = styled.div `

    width: 60px;
    height: 60px;
    background-image: url(${testimonialsImage});

`